// frontend/scr/locales/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import uiTextsEN from './en/uiTexts.json';
import communityExperienceEN from './en/communityExperience.json';
import uiTextsFRCA from './fr-CA/uiTexts.json';

import perceptionEN from './en/perception.json';
import perceptionFRCA from './fr-CA/perception.json';

import capevEN from './en/capev.json';
import capevES from './es/capev.json';
import capevCA from './ca/capev.json';
import capevFR from './fr/capev.json';
import capevFRCA from './fr-CA/capev.json';
import capevFA from './fa/capev.json';
import capevJP from './jp/capev.json';
import capevKN from './kn/capev.json';
import capevMY from './my/capev.json';
import capevPTBR from './pt-br/capev.json';

import conceptsEN from './en/concepts.json';

import longTextsEN from './en/longTexts.json';
import longTextsES from './es/longTexts.json';
import longTextsCA from './ca/longTexts.json';
import longTextsFRCA from './fr-CA/longTexts.json';

import researchProjectsEN from './en/researchProjects.json';

import projectsEN from './en/projects.json';
import projectsFRCA from './fr-CA/projects.json';

import languageNamesEN from './en/languageNames.json';
import languageNamesFRCA from './fr-CA/languageNames.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ca: {
        translation: {
          ...longTextsCA,
          ...capevCA, 
        }
      },
      en: {
        translation: {
          ...uiTextsEN,
          ...communityExperienceEN,
          ...longTextsEN,
          ...perceptionEN,
          ...conceptsEN, 
          ...capevEN, 
          ...projectsEN,
          ...researchProjectsEN,
          ...languageNamesEN,
        }
      },
      es: {
        translation: {
          ...longTextsES,
          ...capevES, 
        }
      },
      fr: {
        translation: {
          ...capevFR, 
        }
      },
      fa: {
        translation: {
          ...capevFA,
        }
      },
      "fr-CA": {
        translation: {
          ...uiTextsFRCA,
          ...longTextsFRCA,
          ...perceptionFRCA,
          ...capevFRCA,
          ...projectsFRCA,
          ...languageNamesFRCA,
        }
      },
      jp: {
        translation: {
          ...capevJP, 
        }
      },
      kn: {
        translation: {
          ...capevKN,
        }
      },
      my: {
        translation: {
          ...capevMY, 
        }
      },
      "pt-BR": {
        translation: {
          ...capevPTBR, 
        }
      },
    },
    lng: 'en', // Idioma per defecte
    fallbackLng: {
      "fr-CA": ["fr", "en"], // El francès del Quebec fa fallback al francès europeu, i després a l'anglès
      "fr": ["en"], // El francès europeu fa fallback a l'anglès
      default: ["en"], // Per la resta d'idiomes, el fallback és l'anglès
    },
    interpolation: {
      escapeValue: false, // Evita escapar HTML
    },
  });

export default i18n;
